import { financeGlobalRepo } from './core';
export type { IFinanceGlobalRepository, FinanceGlobalParams, FinanceGlobalResumo, FinanceGlobalWorkspace, FinanceMatrizCell, FinanceProjetadoRealizado, FinanceEvolucaoAno } from '@modules/financeGlobal';
export const getFinanceGlobalResumo = financeGlobalRepo.getResumo;
